import { render } from "./BigTitle.vue?vue&type=template&id=e6dee502"
import script from "./BigTitle.vue?vue&type=script&lang=js"
export * from "./BigTitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__